<template>
  <!-- 周报——我收到的 -->
  <div class="received">
    <!-- 筛选 -->
    <div class="screen">
      <span>项目：</span>
      <el-select v-model="screen.prjId" size="small" clearable placeholder="全部">
        <el-option v-for="item in weeklyProjects" :key="item.prjId" :label="item.prjName" :value="item.prjId">
        </el-option>
      </el-select>

      <span>提交人：</span>
      <el-input v-model="screen.person" size="small" clearable="" placeholder="请输入人员姓名">
      </el-input>

      <span>内容：</span>
      <el-input v-model="screen.content" size="small" suffix-icon="el-icon-search" placeholder="请输入关键字">
      </el-input>

      <span>状态：</span>
      <el-select v-model="screen.isRead" size="small" clearable placeholder="请选择">
        <el-option v-for="item in states" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>

      <span>日期：</span>
      <el-date-picker v-model="screen.date" size="small" range-separator="至" start-placeholder="开始时间"
        end-placeholder="结束时间" type="daterange">
      </el-date-picker>
      <el-button size="small" type="primary" style="margin-left: 20px" @click="getWeeklyData">查询</el-button>
      <el-button size="small" @click="reset">重置</el-button>
    </div>

    <!-- 周报数据 -->
    <div class="weeklyData">
      <!-- 周报表 -->
      <el-table ref="weeklyTable" height="100%" highlight-current-row :data="weeklyData"
        tooltip-effect="dark" :row-class-name="tableRowClassName" border>
        <el-table-column label="序号" align="center" width="80" type="index">
        </el-table-column>
        <el-table-column label="项目名称" align="center" width="180" prop="prjName" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="日期" align="center" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.reportStartDate + ' 至 ' + scope.row.reportEndDate }}</span>
          </template>
        </el-table-column>
        <el-table-column label="提交人" align="center" width="120" prop="createUserName">
        </el-table-column>
        <el-table-column label="内容" align="center" min-width="300">
          <template #default="{ row }">
            <el-link type="primary" @click="dialogSeeOpen(row)">
              <span class="contentText" :title="row.designManageContent">{{ row.designManageContent }}</span>
            </el-link>
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center" width="120">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isRead == 0" size="small" type="danger">未读</el-tag>
            <el-tag v-if="scope.row.isRead == 1" size="small" type="success">已读</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="提交时间" align="center" width="300" prop="createTime">
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination background layout="total, prev, pager, next" :total="totalCount" :page-count="totalPage"
        :current-page.sync="currentPage">
      </el-pagination>
    </div>

    <!-- 查看弹框 -->
    <weeklySee ref="weeklySee" :report-id="currentRow.reportId" @refreshList="getWeeklyData"></weeklySee>
  </div>
</template>

<script>
import weeklySee from "./weeklySee.vue";
import weeklyService from "@/CommonDP/service/weekly-service";
import { mapState } from "vuex";
import moment from "moment";

export default {
  components: { weeklySee },
  data() {
    return {
      states: [
        { label: "未读", value: 0 },
        { label: "已读", value: 1 }
      ], // 是否已读
      weeklyProjects: [], // 筛选项目

      screen: {
        prjId: "", // 筛选--项目
        person: "", // 筛选--提交人
        content: "", // 筛选--内容
        isRead: "", // 筛选--状态（是否已读）
        date: [], // 筛选--日期
        pageSize: 20,
        pageNum: 1
      },
      weeklyData: [], // 列表数据
      totalCount: 1, // 总数
      totalPage: 1, // 分页总数
      currentPage: 1, // 当前页
      currentRow: {} // 当前行
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),

    // 开始时间
    startDate() {
      if (this.screen.date && this.screen.date.length > 0) {
        return moment(this.screen.date[0]).format("YYYY-MM-DD") + " 00:00:00";
      } else {
        return "";
      }
    },
    // 结束时间
    endDate() {
      if (this.screen.date && this.screen.date.length > 1) {
        return moment(this.screen.date[1]).format("YYYY-MM-DD") + " 23:59:59";
      } else {
        return "";
      }
    }
  },
  watch: {
    currentPage(val) {
      this.screen.pageNum = val;
      this.getWeeklyData();
    }
  },
  mounted() {
    this.getWeeklyData();
  },
  methods: {
    // 把每一行的索引放进row
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex;
    },

    // 获得筛选项目 type: 1我发出的 2我收到的
    async getWeeklyProjects() {
      const params = {
        enterpriseId: this.enterpriseId,
        type: "2"
      };
      const res = await weeklyService.getPrjList(params);
      this.weeklyProjects = res.data;
    },

    // 获得列表数据
    async getWeeklyData() {
      const params = {
        enterpriseId: this.enterpriseId,
        type: "2", // 我收到的
        prjId: this.screen.prjId, // 项目id
        name: this.screen.person, // 提交人
        keyword: this.screen.content, // 关键字
        isRead: this.screen.isRead, // 是否已读
        startDate: this.startDate, // 开始时间
        endDate: this.endDate, // 结束时间
        pageSize: this.screen.pageSize,
        pageNum: this.screen.pageNum
      };
      const res = await weeklyService.getList(params);
      this.totalPage = res.totalPage;
      this.totalCount = res.totalCount;
      this.weeklyData = res.data;
      this.getWeeklyProjects();
      // 父组件刷新未读
      this.$parent.getUnreadNum();
    },

    // 重置
    reset() {
      this.screen = {
        prjId: "", // 筛选--项目
        person: "", // 筛选--提交人
        content: "", // 筛选--内容
        isRead: "", // 筛选--状态（是否已读）
        date: [], // 筛选--日期
        pageSize: 20,
        pageNum: 1
      };
      this.getWeeklyData();
    },

    // 打开新增弹框
    dialogAddOpen() {
      this.$refs.weeklyAdd.dialogAddShow = true;
    },
    // 打开查看弹框
    dialogSeeOpen(row) {
      this.currentRow = row;
      this.$refs.weeklySee.dialogSeeShow = true;
    }
  }
};
</script>

<style lang='scss' scoped>
.received {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .screen {
    width: 100%;
    padding: var(--middle-space) var(--big-space);
    border-bottom: 1px solid #e5e8f1;
    display: flex;
    align-items: center;

    span {
      margin-left: var(--middle-space);
      font-family: "PingFang SC";
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;
      color: var(--common-color);
      white-space: nowrap;
    }

    .el-input {
      width: 234px;
    }

    .el-button {
      padding: 9px 17px;
    }
  }

  .weeklyData {
    width: 100%;
    height: 1px;
    flex-grow: 1;
    padding: 0 var(--big-space);
    display: flex;
    flex-direction: column;

    .el-table {
      flex-grow: 1;
      margin-top: var(--middle-space);
      .contentText {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }

      .el-link {
        margin: 0 var(--small-space);
      }
    }

    .el-pagination {
      margin-left: auto;
      padding: var(--middle-space) 0;
    }
  }
}

/deep/ .el-range-separator {
  width: max-content;
}
</style>
